import { ReactNode } from "react";
import clsx from "clsx";

type BadgeRoundedSquareProps = {
	text?: string;
	icon?: ReactNode;
	backgroundColor?: string;
	textColor?: string;
	iconColor?: string;
	position?: "static" | "absolute" | "relative";
	top?: string;
	right?: string;
	bottom?: string;
	left?: string;
	className?: string;
	onClick?: () => void;
};

export default function BadgeRoundedSquare({
	text,
	icon,
	backgroundColor = "bg-brown",
	textColor = "text-white",
	iconColor = "text-white",
	position = "static",
	top,
	right,
	bottom,
	left,
	className,
	onClick,
}: BadgeRoundedSquareProps) {
	const positioningStyles: React.CSSProperties = {};
	if (position !== "static") {
		positioningStyles.position = position;
		if (top) positioningStyles.top = top;
		if (right) positioningStyles.right = right;
		if (bottom) positioningStyles.bottom = bottom;
		if (left) positioningStyles.left = left;
	}

	return (
		<div
			className={clsx(
				"h-[1.875rem] w-[1.875rem] rounded-[0.43rem] sm:h-10 sm:w-10 sm:rounded-[0.571rem]",
				"flex items-center justify-center",
				"transition-all duration-300",
				backgroundColor,
				onClick && "cursor-pointer",
				className,
			)}
			style={positioningStyles}
			onClick={onClick}
		>
			{icon && <div className={clsx("flex items-center justify-center", iconColor)}>{icon}</div>}
			{text && <p className={clsx("text-cap-s sm:text-cap-l-badge", textColor)}>{text}</p>}
		</div>
	);
}
